<template>
  <v-card flat tile>
    <v-container>
      <h4 class="text-center mb-4 mt-2 grey--text text--darken-3">New Password</h4>
      <v-form ref="reset-form" lazy-validation @keyup.enter="submitForm">
        <v-row justify="center">
          <v-col cols="10" sm="5" md="5" class="py-0">
            <v-text-field
              outlined
              v-model="reset.password"
              autocomplete="new-password"
              @change="reset.password_c=''"
              type="password"
              label="Password"
              :rules="[rules.required,rules.min,rules.password]"
              clearable
              :validate-on-blur="true"
            ></v-text-field>
          </v-col>
          <v-col cols="10" sm="5" md="5" class="py-0">
            <v-text-field
              outlined
              v-model="reset.password_c"
              autocomplete="new-password"
              type="password"
              label="Confirm Password"
              v-on:keyup.enter="submitForm"
              clearable
              :rules="[rules.required]"
              :validate-on-blur="true"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="10" class="py-0 text-center" v-if="error">
            <v-alert type="error">{{error}}</v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-card-actions class="grey lighten-3">
      <v-btn icon to="/">
        <v-icon>fa-home</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="submitForm" :loading="loading">Submit</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "",
  data: () => ({
    loading: false,
    error: "",
    reset: {
      token: "",
      password: "",
      password_c: "",
    },
  }),
  methods: {
    async submitForm() {
      if (!this.$refs["reset-form"].validate()) {
        return;
      }
      if (this.reset.password !== this.reset.password_c) {
        this.reset.password = "";
        this.reset.password_c = "";
        return alert("Passwords dont match");
      }
      this.loading = true;
      this.error = "";
      this.info = "";
      try {
        await this.$api.post("/reset-password", {
          password: this.reset.password,
          token: this.reset.token,
        });
        this.$emit("tab", "login");
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false;
    },
  },
  created() {
    if (this.$route.query.token) {
      this.reset.token = this.$route.query.token;
      setTimeout(
        function () {
          this.tab = "reset";
        }.bind(this),
        100
      );
    }
  },
  computed: {
    rules() {
      return {
        ...this.$helpers.rules,
        match_password_reset: (value) => {
          if (!value) {
            return false;
          }
          if (this.reset.password !== this.reset.password_c) {
            return "Passwords dont match";
          }
          return false;
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
